import { Handle, NodeResizer, Position, type NodeProps } from '@xyflow/react';
import { useQuadro } from '../../application/dependencias';
import { IconeEstado } from '../design-system/icones';
import type { NoGrupoTipo } from './montar-nos';

/** Grupo de um estado: fundo inclinado como papel colado; o conteúdo (cartões) fica reto. */
export function NoGrupo({ data, selected }: NodeProps<NoGrupoTipo>) {
  const nivel = useQuadro((s) => s.nivel);
  const alterarGrupos = useQuadro((s) => s.alterarGrupos);
  const { estado, grupo, quantidade } = data;

  return (
    <div className={`grupo grupo--${nivel}`} style={{ '--cor': estado.cor } as React.CSSProperties}>
      <NodeResizer
        isVisible={selected}
        minWidth={300}
        minHeight={240}
        lineClassName="grupo__redimensionar"
        handleClassName="grupo__alca"
        onResizeEnd={(_, p) =>
          alterarGrupos([{ uuid: grupo.uuid, x: p.x, y: p.y, largura: p.width, altura: p.height, rotacao: grupo.rotacao }])
        }
      />
      <div className="grupo__fundo" style={{ transform: `rotate(${grupo.rotacao}deg)` }} />
      <Handle type="target" position={Position.Left} className="ponta-oculta" isConnectable={false} />
      <Handle type="source" position={Position.Right} className="ponta-oculta" isConnectable={false} />
      {data.editandoPor && <span className="no-editando">{data.editandoPor} está editando</span>}
      <header className="grupo__cabecalho">
        <span className="grupo__icone">
          <IconeEstado nome={estado.icone} tamanho={nivel === 'minimo' ? 44 : 22} />
        </span>
        <h2 className="grupo__titulo">{estado.nome}</h2>
        <span className="grupo__contador" aria-label={`${quantidade} processos`}>
          {quantidade}
        </span>
      </header>
    </div>
  );
}
